import { render } from "./SignatureDialog.vue?vue&type=template&id=b0e56364&scoped=true"
import script from "./SignatureDialog.vue?vue&type=script&lang=js"
export * from "./SignatureDialog.vue?vue&type=script&lang=js"

import "./SignatureDialog.vue?vue&type=style&index=0&id=b0e56364&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e56364"]])

export default __exports__